import React, {useState, useEffect, useCallback} from "react";
import "../App.css";

import Axios from "axios";

import {
    MDBBtn,
    MDBTable,
    MDBTableHead,
    MDBTableBody,
    MDBInput, MDBPaginationLink, MDBPaginationItem, MDBPagination,
} from "mdb-react-ui-kit";
import {Link, useNavigate} from "react-router-dom";

import {
    backendPathEmployees, ENTRIES_PER_PAGE
} from "../Constants";
import {matchesSearch} from "../functions/matchPerson";
import {faArrowDown} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import EmployeeEntry from "../components/EmployeeEntry";
import {checkVisibility} from "../functions/visibility";
import {getPaginationNumbers} from "../functions/pagination";
import {loadPermissions} from "../functions/permissions";
import TopNavbar from "../components/Navbar";


function Employees() {
    const navigate = useNavigate();

    const [employeeList, setEmployeeList] = useState([]);
    const [filteredEmployeeList, setFilteredEmployeeList] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [sortRating, setSortRating] = useState(false);
    const [filterRecommendation, setFilterRecommendation] = useState(false);
    const [startIndex, setStartIndex] = useState(0);
    const [numberOfEmployees, setNumberOfEmployees] = useState(0);
    const [pageNumbers, setPageNumbers] = useState([]);

    const [writePermission, setWritePermission] = useState(false);
    const [readPermission, setReadPermission] = useState(false);


    const getEmployees = useCallback(() => {
        Axios.get(`${backendPathEmployees}employees.php`).then((response) => {
            if (response.data) {
                setEmployeeList(response.data);

                setFilteredEmployeeList(response.data.filter(value => matchesRecommendation(value))
                    .filter(value => checkVisibility(value["PartnerID"], "partner"))
                    .filter(value => matchesSearch(value, searchValue)));
            }
        });
    }, []);

    useEffect(() => {
        loadPermissions(navigate, setReadPermission, setWritePermission);
    }, []);

    useEffect(() => {
        console.log("effect 0");
        getEmployees();
    }, [getEmployees]);

    useEffect(() => {
        console.log("effect 4");
        setNumberOfEmployees(filteredEmployeeList.length);
    }, [filteredEmployeeList]);

    useEffect(() => {
        console.log("effect 2");
        setPageNumbers(getPaginationNumbers(numberOfEmployees, ENTRIES_PER_PAGE));
    }, [numberOfEmployees]);

    useEffect(() => {
        console.log("effect 3");
        setFilteredEmployeeList(employeeList.filter(value => matchesRecommendation(value))
                                            .filter(value => checkVisibility(value["PartnerID"], "partner"))
                                            .filter(value => matchesSearch(value, searchValue)));
        setStartIndex(0);
    }, [filterRecommendation, searchValue]);


    function matchesRecommendation(value) {
        if (!filterRecommendation) {
            return true;
        }
        return value.Recommendation > 0;
    }

    function compareByRating(val1, val2) {
        if (!sortRating) {
            return 0;
        }
        if(val1.Rating > val2.Rating) {
            return -1;
        }
        if(val1.Rating < val2.Rating) {
            return 1;
        }
        return 0;
    }

    return (
        <>
        <TopNavbar readPermissionInitial={readPermission} writePermissionInitial={writePermission}/>
        <div className="main">
            <div className="header-above-table d-flex align-items-center">
                <h2>Liste aller Betreuungskräfte</h2>
                <div className="search-btns">
                    <MDBInput label='Suche' type='text' onChange={(e) => setSearchValue(e.target.value)}/>
                </div>
                <Link className="right" to="/new-employee">
                    <MDBBtn className="btn">Hinzufügen</MDBBtn>
                </Link>
            </div>

            <MDBTable align='middle'>
                <MDBTableHead className="table-head">
                    <tr className="underlined-header">
                        <th scope='col'>Name</th>
                        <th scope='col'>Vorname</th>
                        <th scope='col'>Partner</th>
                        <th scope='col'>Nationalität</th>
                        <th scope='col'>Deutschkenntnisse</th>
                        <th scope='col' className='header-with-arrow'
                            onClick={(event) => setSortRating(!sortRating)}>
                            <nobr>
                                Bewertung
                                <FontAwesomeIcon
                                    className={sortRating ? 'btn-icon header-arrow-selected' : 'btn-icon header-arrow'}
                                    icon={faArrowDown}/>
                            </nobr>
                        </th>
                        <th scope='col'>
                            <p className={filterRecommendation ? 'header-button-selected' : 'header-button'}
                               onClick={(event) => setFilterRecommendation(!filterRecommendation)}>
                                Empfehlung
                            </p>
                        </th>
                        <th scope='col'>Status</th>
                        <th scope='col'></th>
                    </tr>
                </MDBTableHead>
                <MDBTableBody>
                    <tr className="table-body">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    {filteredEmployeeList
                        .sort(compareByRating)
                        .slice(startIndex, startIndex+ENTRIES_PER_PAGE)
                        .map((val, key) => {
                            return (
                                <EmployeeEntry employee={val} key={key}></EmployeeEntry>
                            );
                        })}
                </MDBTableBody>
            </MDBTable>

            <nav className="page-selection-aria">
                <MDBPagination className='page-selection'>
                    <MDBPaginationItem disabled={startIndex <= 0}
                                       onClick={() => {if (startIndex >= ENTRIES_PER_PAGE) {
                                           setStartIndex(startIndex-ENTRIES_PER_PAGE)
                                       }}}>
                        <MDBPaginationLink>Zurück</MDBPaginationLink>
                    </MDBPaginationItem>

                    {
                        pageNumbers.map((val, key) => {
                            if (val === -1) {
                                return (
                                    <p className={"pt-1 ms-2 me-2 paging-dots"}>...</p>
                                );
                            } else {
                                return (
                                    <MDBPaginationItem key={key} onClick={() => {
                                        setStartIndex((val-1)*ENTRIES_PER_PAGE);
                                    }}>
                                        <MDBPaginationLink>{val}</MDBPaginationLink>
                                    </MDBPaginationItem>
                                );
                            }
                        })
                    }

                    <MDBPaginationItem disabled={startIndex/ENTRIES_PER_PAGE >= Math.ceil(numberOfEmployees/ENTRIES_PER_PAGE) -1}
                        onClick={() => {if (startIndex/ENTRIES_PER_PAGE < Math.ceil(numberOfEmployees/ENTRIES_PER_PAGE) -1) {
                            setStartIndex(startIndex+ENTRIES_PER_PAGE)
                        }}}>
                        <MDBPaginationLink>Weiter</MDBPaginationLink>
                    </MDBPaginationItem>
                </MDBPagination>
            </nav>

        </div>
        </>
    );
}

export default Employees;